import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.course_projects_index> = {
  queryKey: 'courseProjects',
  query: QUERY,
}

export default List
